import React from "react";
import Button from "../../components/Button";
import Cancel from "../../icons/Cancel";
import AdvancedText from "../../components/AdvancedText";
import { privacy } from "../../locales/ko/privacy";
import { typography } from "../../styles/typography";
import colors from "../../styles/colors";
import { cookie } from "../../locales/ko/cookie";

const CookiePolicy = () => {

    return (
        <div style={styles.container}>
            <div style={{ ...styles.subcontainer }}>
                <div style={styles.header}>
                    <Button style={styles.cancel} onClick={() => window.close()}>
                        <Cancel />
                    </Button>
                    <label style={styles.label} className="title_s_18_medium mt-16">Eyeary Cookie Policy</label>
                    <div style={styles.divider} />
                </div>
                <AdvancedText style={styles.content} texts={cookie.content} parseProps={{ style: { color: '#fff' } }} />
            </div>
        </div>
    )
}


const styles = {
    container: {
        position: 'absolute',
        background: '#070E10',
        display: 'flex',
        width: '100%',
        height: '100dvh',
        overflow: 'hidden'
    },
    header: {
        display: 'flex',
        flexDirection: 'column'
    },
    subcontainer: {
        marginTop: 20,
        background: "#1C2226",
        flex: 1,
        width: '100%',
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        display: 'flex',
        flexDirection: 'column',
        padding: 14

    },
    cancel: {
        alignSelf: "flex-end"
    },
    label: {
        color: '#fff'
    },
    divider: {
        backgroundColor: '#23292E',
        height: '1px',
        width: '100%',
        marginTop: 24,
        marginBottom: 24
    },
    content: {
        ...typography.body["14_regular"],
        color: colors.mono400,
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'scroll'
    },
}

export default CookiePolicy